import { render, staticRenderFns } from "./CatalogPage.vue?vue&type=template&id=7f905320&scoped=true"
import script from "./CatalogPage.vue?vue&type=script&lang=js"
export * from "./CatalogPage.vue?vue&type=script&lang=js"
import style0 from "./CatalogPage.vue?vue&type=style&index=0&id=7f905320&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f905320",
  null
  
)

export default component.exports